import type { FC } from "react";
import { Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import { headerRouteArray } from "../../utils/routesConfig";
import { useCopy } from "../../utils/globalContext";
import { getTermsAccepted } from "../../store/auth";
import { KivraHeader } from "./KivraHeader";

export const KivraHeaderRouter: FC = () => {
  const copy = useCopy();
  const termsAccepted = useSelector(getTermsAccepted);
  return (
    <Switch>
      {headerRouteArray(termsAccepted).map(
        ({ path, headerBodyKey, headerTitleKey, appExact }, key) => {
          const header = headerBodyKey
            ? (
              <KivraHeader
                title={copy(...headerTitleKey)}
                body={copy(...headerBodyKey)}
              />
            )
            : <KivraHeader title={copy(...headerTitleKey)} />;
          return (
            <Route
              exact={appExact}
              path={path}
              render={() => header}
              key={key}
            />
          );
        },
      )}
    </Switch>
  );
};
